import React, { useId, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Power, X } from 'lucide-react'
import { tr } from 'i18n'
import ActorPinField from 'components/Erp/ActorPinField/ActorPinField.tsx'
import s from '../Management.module.scss'

type Props = { name: string; active: boolean; busy: boolean; error: string; onClose: () => void; onConfirm: (pin: string) => void }

export default function DriverActivityDialog({ name, active, busy, error, onClose, onConfirm }: Props) {
  useTranslation()
  const titleId = useId()
  const [pin, setPin] = useState('')
  const valid = /^[0-9]{4}$/.test(pin)
  return <div className={s.overlay}>
    <form className={s.dialog} role="dialog" aria-modal="true" aria-labelledby={titleId}
      onSubmit={event => { event.preventDefault(); if (valid && !busy) onConfirm(pin) }}>
      <h2 id={titleId}><Power size={20} aria-hidden="true" />{tr(active ? 'Активация водителя' : 'Деактивация водителя')}</h2>
      <p>{name}</p>
      <p className={s.muted}>{tr('Подтвердите изменение активности водителя своим PIN.')}</p>
      {error && <div className={s.error} role="alert">{tr(error)}</div>}
      <ActorPinField value={pin} onChange={setPin} disabled={busy} />
      <div className={s.footer}>
        <button type="button" className={s.button} disabled={busy} onClick={onClose}><X size={14} aria-hidden="true" />{tr('Отмена')}</button>
        <button className={s.primary} disabled={busy || !valid}>{tr(active ? 'Активировать' : 'Деактивировать')}</button>
      </div>
    </form>
  </div>
}
